import { NextPageContext } from 'next'
import { PlatformConfig } from '@reward-platform/shared-schemas'
import {
  getAviosBaseUrl,
  getWhitelabelPlatformConfigForHost,
  isWhitelabelPlatform,
} from '~/utils/platform'
import { PlatformError } from '~/utils/errors'
import { isLocal } from '~/utils/envChecks'
import { redirectResponse, getPlatformConfigFromCookies } from '../utils'
import {
  getCookiesForClientOrServer,
  getHostForClientOrServer,
  isServerPageContext,
} from './pageContext.utils'

export const handleRedirectToAviosPlatform = (pageContext: NextPageContext, enabled = true) => {
  const isServer = isServerPageContext(pageContext)
  if (!isServer || isLocal()) {
    return
  }

  const currentUrl = pageContext.req.url
  const nextUrl = getAviosBaseUrl()
  const shouldRedirectToAvios = enabled && !currentUrl?.includes(nextUrl)
  if (shouldRedirectToAvios) {
    redirectResponse(pageContext.res, nextUrl, 301)
  }
}

export const getPlatformConfigFromPageContext = (context: NextPageContext): PlatformConfig => {
  try {
    const requestHost = getHostForClientOrServer(context)
    if (isWhitelabelPlatform()) {
      return getWhitelabelPlatformConfigForHost(requestHost, { locale: context.locale })
    }

    // Else is avios platform
    const cookies = getCookiesForClientOrServer(context)
    return getPlatformConfigFromCookies(cookies)
  } catch (error) {
    if (error instanceof PlatformError) {
      error.logRequestToDatadog(context.req)
    }

    throw error
  }
}
